<template>
  <b-dialog
    class="live-admin"
    :visible="isVisible" 
    :title="title"
    :cancelButtonText="$t('common.cancel')"
    :buttonText="$t('common.confirm')"
    @close="close" 
    @cancel="close"
    @submit="setUserAdminState"
  >
    <p>{{confirmTxt}}</p>
  </b-dialog>
</template>

<script lang="ts" setup>
import { computed, onMounted, ref, Ref } from 'vue';
import { BDialog } from '@bilibili-intl/components';
import emitter, { EB_EVENT_NAME, IOpenAdminModalData } from '@/utils/eventbus';
import roomService from '@/service/room';
import { IUserAdminState } from '@/service/room/types';
import toast from '../toast';
import { IToastOptions } from '../toast/toast-types';
import useI18n from '@/locales/index';


const toastProps: IToastOptions = {
  duration: 3000,
  appendTo: '.live-comment-container',
};

const isVisible = ref(false);
const adminInfo: Ref<IOpenAdminModalData | null> = ref(null);


const $t = useI18n().global.t;

const onModalOpen = (data: IOpenAdminModalData) => {
  isVisible.value = true;
  adminInfo.value = data;
};

onMounted(() => {
  emitter.on(EB_EVENT_NAME.OPEN_ADMIN_MODAL, onModalOpen);
});


const title = computed(() => {
  if (!adminInfo?.value) {
    return '';
  }
  return adminInfo.value?.adminState === IUserAdminState.admin
    ? $t('userCard.promote')
    :$t('userCard.demote');
});

const confirmTxt = computed(() => {
  if (!adminInfo?.value) {
    return '';
  }
  return adminInfo.value?.adminState === IUserAdminState.admin
    ? $t('modals.promoteConfirm', {username: adminInfo.value.username})
    : $t('modals.demoteConfirm', {username: adminInfo.value.username});
});

const close = () => {
  isVisible.value = false;
  adminInfo.value = null;
};

// 设置用户禁言状态
const setUserAdminState = async () => {
  if (!adminInfo.value) {
    return;
  }
  const { roomId, mid, adminState: state} = adminInfo.value;
  try {
    const resp = await roomService.setUserAdminState(
      roomId,
      mid,
      state,
    );
    const message = resp.code === 0
      ? (
        adminInfo.value?.adminState === IUserAdminState.admin 
          ? $t('modals.promoteSuccess', {username: adminInfo.value.username})
          : $t('modals.demoteSuccess')
      )
      : resp.message;
    toast({
      ...toastProps,
      message,
    });
  } catch (err: any) {
    toast({
      ...toastProps,
      message: err?.message,
    });
  } finally {
    close();
  }
};

</script>

<style lang="less">
</style>